var LayerModelBase = require('./layer-model-base');

var GMapsBaseLayer = LayerModelBase.extend({
  OPTIONS: ['roadmap', 'satellite', 'terrain', 'custom'],
  defaults: {
    type: 'GMapsBase',
    visible: true,
    baseType: 'gray_roadmap',
    style: null
  }
});

module.exports = GMapsBaseLayer;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/map/gmaps-base-layer.js
// module id = 1561
// module chunks = 6